module.exports = __webpack_public_path__ + "67a69d64cbb4f2adc887807fce2bb5c4.svg";